import React, { useState } from "react";
import { connect } from "react-redux";
import { optOutEmailPublic } from "../../../domain/accts/acctsActions";
import StatusMessage from "../../presentational/StatusMessage";
import * as StatusMessages from "../../../constants/StatusMessages";
import { defineMessages, FormattedMessage } from "react-intl";
import track from "react-tracking";
import RadioFormGroup from "../../common/form/RadioFormGroup/RadioFormGroup";
const messages = defineMessages({
    optOutEmailYes: {
        id: "profile.okEmail.yes",
        defaultMessage: "Yes"
    },
    optOutEmailNo: {
        id: "profile.okEmail.no",
        defaultMessage: "No"
    }
});
const optOutEmailOptions = [
    {
        value: "yes",
        label: messages.optOutEmailYes
    },
    {
        value: "no",
        label: messages.optOutEmailNo
    }
];
function EmailOptOutPublic(props) {
    const [optOutEmail, setOptOutEmail] = useState(false);
    const handleChange = (okEmail) => {
        setOptOutEmail(okEmail === "" ? false : okEmail === "yes");
        props.optOutEmailPublic(props.location.query.token);
    };
    return (<div className="wrapper wrapper_narrow">
			<div className="vr vr_x4">
				<h2 className="hdg js-pageHeader">
					<FormattedMessage id="emailOptOut.header" defaultMessage="Email Preferences"/>
				</h2>
			</div>

			<StatusMessage isError={!props.emailOptOutIsSuccess} isSuccess={props.emailOptOutIsSuccess} isActive={props.emailOptOutIsSuccess !== null ? true : false} customMessage={props.emailOptOutIsSuccess ?
        StatusMessages.EMAILOPTOUT.SUCCESS :
        ""} domain="emailOptOut" autoReset={false}/>

			<StatusMessage isError isActive={props.emailOptOutError ? true : false} error={props.emailOptOutError ? props.emailOptOutError : null} customMessage={StatusMessages.EMAILOPTOUT.FAIL} domain="emailOptOut" autoReset={false}/>

			<div className="vr vr_x5">
				<div className="text">
					<p>
						<FormattedMessage id="emailOptOut.message" defaultMessage="Once you opt out, DCMS will not communicate with you via email nor will it be able to email you for the limited purpose of providing you with site access (e.g., username retrieval, password resets) unless you give DCMS permission."/>
					</p>
					<div style={{ paddingTop: "10px" }}>
						<span style={{ paddingBottom: "8px", fontWeight: 600, display: "block" }}>
							<FormattedMessage tagName="h2" id="emailOptOut.checkbox.title" defaultMessage="Opt out of future email communications?"/>
						</span>
					</div>

					<div className="vr vr_x5">
						<RadioFormGroup name="optOutEmail" label={null} value={(optOutEmail == null ? ""
        : optOutEmail ? "yes"
            : "no")} onChange={handleChange} options={optOutEmailOptions} 
    // error={errors.okEmail}
    // backendError={backendErrors.canSendCollectionEmail}
    suppressAria/>
					</div>
				</div>
			</div>

			<StatusMessage isLoad isActive={props.emailOptOutIsLoading}/>
		</div>);
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    emailOptOutError: state.accts.error,
    emailOptOutIsLoading: state.accts.isLoading,
    emailOptOutIsSuccess: state.accts.isSuccess,
    locale: state.i18n.locale
});
const bindActionsToProps = {
    optOutEmailPublic
};
/* Create and export container component that wraps EmailOptOutPublic for property binding */
export default track({ page: "EmailOptOutPublic" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(EmailOptOutPublic));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/public/EmailOptOutPublic.tsx